// extracted by mini-css-extract-plugin
export default {"heading":"_2dy97U8B","portrait":"_1gfCa2xK","teamMember":"_2aIlLfJ3"};